module.exports = __webpack_public_path__ + "img/ic_book_default.dfa0fc9b.png";